<div *ngIf="formGroup" class="login">
  <div class="form">
    <mat-form-field *ngIf="!isCodeRequired" appearance="standard">
      <mat-label class="username__label">{{'Email' | translate}}</mat-label>
      <input
        autocomplete="email"
        id="email"
        name="email"
        type="text"
        (keydown.enter)="login()"
        [formControl]="usernameFormControl"
        [placeholder]="'Email' | translate"
        class="username__input"
        data-cy="login.username"
        matInput>
      <mat-error
        *ngIf="usernameFormControl.hasError('required')"
        class="username__error">{{'Email is required' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!isCodeRequired" appearance="standard">
      <mat-label class="password__label">{{'Password' | translate}}</mat-label>
      <input
        autocomplete="current-password"
        id="current-password"
        (keydown.enter)="login()"
        [formControl]="passwordFormControl"
        [placeholder]="'Password' | translate"
        class="password__input"
        data-cy="login.password"
        matInput
        required
        type="password">
      <mat-error
        *ngIf="passwordFormControl.hasError('required')"
        class="password__error">{{'Password is required' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="isCodeRequired" appearance="outline">
      <mat-label class="code__label">{{'2FA Code' | translate}}</mat-label>
      <input
        autocomplete="2fa-code"
        id="2fa-code"
        name="2fa-code"
        type="text"
        (keydown.enter)="login()"
        [formControl]="codeFormControl"
        [placeholder]="'2FA Code' | translate" class="code__input"
        data-cy="login.code"
        matInput
        maxlength="6"
        minlength="6"
        required>
      <mat-error
        *ngIf="codeFormControl.hasError('required')"
        class="password__error">{{'2FA Code is required' | translate}}</mat-error>

      <mat-error
        *ngIf="codeFormControl.hasError('minlength')"
        class="password__error">{{'Code must contains 6 characters' | translate}}</mat-error>
    </mat-form-field>

    <button
      (click)="login()"
      class="button button--rainbow form__submit-button"
      data-cy="login.submit"
      type="submit"
    >{{'Login' | translate}}</button>

    <lib-auth-reset-password-link
      *ngIf="!isCodeRequired"
      [link]="resetPasswordLink"></lib-auth-reset-password-link>
    <div (click)="showFirstStepForm()" *ngIf="isCodeRequired" class="previous">
      <mat-icon class="">arrow_back</mat-icon>
      <span class="previous__label">{{'Return' | translate}}</span>
    </div>
  </div>
</div>
